export default "/images/vendor/@coreui/icons/svg/flag/cif-ws.svg?2f3cd73cd356214d5762cbeddb67fb26";